// noinspection JSUnusedGlobalSymbols
export default {

    lastDryRun: state => state.lastDryRun,

    lastSyncResult: state => state.lastSyncResult,

    mocoSettings: state => state.mocoSettings,

}
